export const costs: [string, string][] = [
  [
    'Sin imagen anatómica del área tratada',
    'No podés mostrarle al paciente exactamente qué zona y qué punto trabajás',
  ],
  [
    'Sin diagnóstico diferencial visual por patología',
    'Cada sesión construida desde la memoria, sin sistema de referencia que la respalde',
  ],
  [
    'Sin los 26 protocolos clínicos organizados',
    'Improvisás las combinaciones de puntos porque no tenés fórmulas maestras a mano',
  ],
  [
    'Sin el Reloj Biológico de los Meridianos',
    'Perdés la herramienta diagnóstica más poderosa de la MTC: el horario del síntoma',
  ],
  [
    'Sin Psicosomática Oriental',
    'Tratás el síntoma físico sin entender la emoción que lo sostiene desde adentro',
  ],
  [
    'Sin Maestría en Manipulación',
    'Aplicás el punto correcto pero sin optimizar la técnica que determina el resultado',
  ],
  [
    'Sin Auriculoterapia Clínica',
    'Perdés el microsistema más rápido y accesible del cuerpo: todo el cuerpo en un oído',
  ],
  [
    'Sin Farmacopea Externa',
    'Tus sesiones no tienen la dimensión sensorial y transdérmica que podrían tener',
  ],
  [
    'Sin el Atlas Ancestral',
    'El mismo ciclo de consulta sin respaldo visual, sin sistema clínico y sin la autoridad que tus pacientes merecen ver',
  ],
]
